var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredictorYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 12,
    viewBox: "0 0 90 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 11,
    rx: 5.5,
    fill: "#FDD63C",
    stroke: "#FDD63C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 0.5,
    width: 30,
    height: 11,
    fill: "#F3F3F3",
    stroke: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 0.5H84C87.0376 0.5 89.5 2.96243 89.5 6C89.5 9.03757 87.0376 11.5 84 11.5H60.5V0.5Z",
    fill: "#F3F3F3",
    stroke: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictorYellow);
export default __webpack_public_path__ + "static/media/predictorYellow.45dcd6585551b051eabf3a14dd23a958.svg";
export { ForwardRef as ReactComponent };